/**
 * Demo-Modus Utilities für Kundenpräsentationen
 * Usage: https://inspecdoor.frankrath.com?demo=true
 */

export const isDemoMode = (searchParams?: URLSearchParams): boolean => {
  if (typeof window !== 'undefined') {
    return new URLSearchParams(window.location.search).get('demo') === 'true';
  }
  return searchParams?.get('demo') === 'true' || false;
};

export const getDemoToggleUrl = (currentDemo: boolean): string => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    if (currentDemo) {
      url.searchParams.delete('demo');
    } else {
      url.searchParams.set('demo', 'true');
    }
    return url.toString();
  }
  return currentDemo ? '/' : '/?demo=true';
};

export const getCustomerFilter = (demoMode: boolean) => {
  return demoMode 
    ? { is_demo: true }  // Demo-Kunden
    : { is_demo: false }; // Echte Kunden
};

export const getDeliveryLocationFilter = (demoMode: boolean) => {
  return demoMode
    ? {} // Alle Demo-Lieferorte (über customer-Filter automatisch)
    : {}; // Nur Hansestadt Lübeck
};

export const getDoorFilter = (demoMode: boolean) => {
  return demoMode
    ? {} // Alle Demo-Türen (über location-Filter automatisch)  
    : { delivery_location_id: '7b58d8d4-46e6-4850-a633-0e85e7fb9f04' }; // Nur Baltic Gesamtschule
};
